// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Dashboard State
// -------------------------------
export interface DashboardState extends EntityState<any> {
  common?: any;

}

// -------------------------------
//  Dashboard Adapter
// -------------------------------
export const dashboardAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Dashboard Initial State
// -------------------------------
export const initialState: DashboardState = dashboardAdapter.getInitialState(
  {
  common: null,
  },
);
